import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core'; //AfterViewInit
import { FormServiceService } from 'src/app/services/publications/form-service.service';
import { IonSlides, ModalController } from '@ionic/angular';
import { LkfilmViewBySlidesComponent } from 'src/app/components/lkfilm-view-by-slides/lkfilm-view-by-slides.component';
import { ActualizacionServiceService } from 'src/app/services/actualizacion/Actualizacion-service.service';
import Swal2 from "sweetalert2";
import { ToastController } from '@ionic/angular';
import { FingerprintAIO } from '@ionic-native/fingerprint-aio/ngx';
//import { PagoVerificacionComponent } from 'src/app/components/pago-verificacion/pago-verificacion.component';
//import { SliderInformationComponent } from 'src/app/components/slider-information/slider-information.component';
import {RequestService} from "../../../services/request/request.service";
import { WalletServiceService } from 'src/app/services/wallet/wallet-service.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { Capacitor } from '@capacitor/core';
import { SocialInteractionNotificationService } from 'src/app/services/notifications/social-interaction-notification.service';
import { SecureOperationFeedbackService } from 'src/app/services/ui/secure-operation-feedback.service';
//import { r3JitTypeSourceSpan } from '@angular/compiler';

//import type { SwiperOptions } from 'swiper';


//import  Swal from 'sweetalert2';
//import { InAppPurchase2,IAPProduct } from '@awesome-cordova-plugins/in-app-purchase-2/ngx';
// Declare shaka as a global variable

@Component({
  selector: 'app-main-publications-swipecontainer',
  templateUrl: './main-publications-swipecontainer.component.html',
  styleUrls: ['./main-publications-swipecontainer.component.scss']
})
export class MainPublicationsSwipecontainerComponent implements OnInit { //OnChanges, AfterViewInit


  containerWidth: string = '100vw';
  @Input() window_width: any;
  SlideInteraction:boolean=true;
  @Input() general_index: any=0;
  @Input() media_index: any=0;
  checkIntervalId: any;
   isFetchingPublications = false;
  timeoutId;
  public web: boolean =false;
// If your project types complain, type as any; IonSlides uses Swiper under the hood.
slideOpts: any = {
  direction: 'vertical',
  initialSlide: 0,
    speed: 699,         // a bit lower → fewer GPU spikes
  loop: false,                // safer on iOS (no DOM cloning)
  effect: 'slide',            // keep it basic
  threshold: 10,              // need a real swipe to start
  resistanceRatio: 0.65,      // less rubber-banding
  preventInteractionOnTransition: true, // ignore swipes until animation ends
  touchReleaseOnEdges: true,
  observer: true,
  observeParents: true,
  // If your IonSlides/Swiper version supports it, this is the most stable:
  // cssMode: true,           // native scroll; comment out if you get an unknown option error
  preloadImages: false,
  lazy: true,                 // only load what’s needed
};

  public showSwipeIntro: boolean = false;
  public showFeedSwipeHint: boolean = false;
  public showPublicationSkeleton: boolean = false;
  numero=10
  mostrar:boolean=false;
  lanzamiento
  @Input() pr: any;
  public msg:string="Leyendo.."
  @ViewChild('slides') slides: IonSlides;
  NextSlide: any;
  public ChunkedPublications: any[] = [];
  public OldPublications: any[] = [];
  public valueSelect:string;
  //public publicationsLoaded = false;
  public publications: any[] = [];
  public publicationSkeletonSlots = [0, 1, 2, 3];
  public activeChunkIndex = 0;
  @Input() initial_index = 0;
  productId2: string = '1618';
  media_width: string='46.6vw';
  public HubbleExpired: boolean = false;
  private wheelLock = false;
  private removeWheelListener: (() => void) | null = null;
  private publicationSkeletonTimer?: ReturnType<typeof setTimeout>;
  constructor(        private actualizacionservice:ActualizacionServiceService,private formService:FormServiceService,private Mctrl:ModalController, private toastController: ToastController,
    private faio:FingerprintAIO, private request: RequestService, private walletService: WalletServiceService, private profile:ProfileService, private socialNotifications: SocialInteractionNotificationService,
    private secureFeedback: SecureOperationFeedbackService, ) { }


/*
  ngOnChanges(changes: SimpleChanges): void {
    console.log('Publication main swipe Changes detected at ', changes);
    if (changes.pr) {
      // Handle changes to the 'pr' input property
      console.log("pr changed in child component", changes.pr.currentValue);
      this.pr = changes.pr.currentValue;
      console.log( 'main pr:', this.pr);
    console.log( 'main pr:', this.pr.id);
    console.log( 'main pr:', this.pr.kyc);
    }
    //if (changes !== undefined) {

      //if('publications' in changes) {
     //   this.ChunkedPublications = changes.publications.currentValue;
   //   }
   // }
  }
  */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['window_width'] && changes['window_width'].currentValue !== undefined) {
      const newWidth = changes['window_width'].currentValue;
      this.containerWidth = '100vw';
      this.media_width= newWidth >= 510 ? '36.3vw' : '46.6vw';
    }

    if (changes['general_index'] && changes['general_index'].currentValue !== undefined && !this.formService.mediaTemplate) {
      if (changes['general_index'].currentValue > changes['general_index'].previousValue) {
        this.slides.slideNext();
      } else {
        if(this.slides){
          this.slides.slidePrev();
        }
      
      }
    }
    

  }

  trackByChunkIndex(index: number): number {
    return index;
  }

  trackByPublicationIndex(index: number): number {
    return index;
  }

  shouldRenderChunkMedia(index: number): boolean {
    return Math.abs(index - this.activeChunkIndex) <= 1;
  }

  get_class(index) {
    // console.log('se lllama get_class');


    if((index % 4 === 0)) {
      return 'reminder0 ';
    }
    else if(index % 4 === 1){
      return 'reminder1 ';
    }
    else if(index % 4 === 2){
      return 'reminder2 ';
    }else{
      return 'reminder3 ';
    }

    // if((index % 4 === 0)) {
    //   if (this.formService.lkpublication.index_close === index){
    //     return 'reminder0 shadow ';
    //   }else{
    //     return 'reminder0 ';
    //   }
    // }else if(index % 4 === 1) {
    //   if (this.formService.lkpublication.index_close === index){
    //     return 'reminder1 shadow ';
    //   }else {
    //     return 'reminder1';
    //   }
    // }else if(index % 4 === 2) {
    //   if (this.formService.lkpublication.index_close === index){
    //     return 'reminder2 shadow';
    //   }else {
    //     return 'reminder2';
    //   }
    // }
    // else {
    //   if (this.formService.lkpublication.index_close === index){
    //     return 'reminder3 shadow ';
    //   }else {
    //     return 'reminder3';
    //   }
    // }

  }
  get_class2(index) {
    // console.log('se lllama get_class2');

    if(this.formService.lkpublication.index_close===index){
      return 'shadow'
    }




  }
    /*
  pauseAllVideos() {
    let allVideos = document.getElementsByTagName('video');
    for (let i = 0; i < allVideos.length; i++) {
      allVideos[i].pause();
    }
  }
  async playVideosInActiveSlide() {
    let currentIndex = await this.slides.getActiveIndex();
    let activeSlideElement = document.getElementById('slide-' + currentIndex);
    if (activeSlideElement) {
      let videos = activeSlideElement.getElementsByTagName('video');
      for (let i = 0; i < videos.length; i++) {
        videos[i].play();
      }
    }
  }

  dismiss() {
    this.Mctrl.dismiss({
      'dismissed': true
    });
  }

  openComponentVideo0(){//index
    this.Mctrl.create({
        component: LkfilmViewBySlidesComponent,
        canDismiss: true, // (forced globally for swipe close on all modals)
        componentProps: {
          publications:this.publications,
          //index: index
        }
    }).then((modal)=>{
        modal.present();
        modal.onDidDismiss().then((data)=>{
          let index_close = this.formService.lkpublication.index_close;
          console.log('index after close', index_close);
          this.publications[index_close]['shadow'] = true;
          console.log(this.publications[index_close]);
        });
    });
}


  async fetchPublications2(){
    const result = await this.actualizacionservice.getPublications(null, false, null, false, null);
    console.log("result en publication media template",result);
    return result;
  }

  public async getPublications2(event: any) {
    const result: any[] = await this.actualizacionservice.getPublications(event, false, null, null, null);
    let old_publications = result; // Use the result instead of this.publications
    this.publications = [];
    // let i = 0;
    old_publications.forEach((publication) => {
      if ('quienpuedever' in publication) {
        if (publication['quienpuedever'].includes('Para todos')) {
          // if (i <= 3) {
          this.publications.push(publication);
          // i++;
          // }
        }
      }
    });
  }
  

  async new_page2() {
    this.actualizacionservice.current_page++;
    console.log('pagina en actualizacion service', this.actualizacionservice.current_page);
    let publications_from_server;
    publications_from_server= await this.fetchPublications2();
    console.log('publications from server', publications_from_server);
    if (publications_from_server.length == null || publications_from_server.length === 0 ) {
      Swal2.fire({
        title: 'Easy there, do not scroll so fast',
        icon: 'warning',
        confirmButtonText: 'Understood',
        color: '#ffffff',
        background: '#010f4e',
      });
      return;
    }
    let i = 0;
    for (const pub of publications_from_server) {
      //if (pub['publication_type'] == 'lkfilm'){
        i++;
        this.publications.push(pub);
      //}
    }
    //no hubo publicaciones de seguidores en la pagina X avanzar a la siguiente
    console.log('number of publications with lkfilm', i);
    if (i==0 && this.actualizacionservice.current_page < 4){
      this.actualizacionservice.current_page++;
      await this.new_page2();
    }else if(i==0 && this.actualizacionservice.current_page >= 4) {
      Swal2.fire({
        title: 'Your finger swipe speed exceeded the limit',
        icon: 'warning',
        confirmButtonText: 'Understood',
        color: '#ffffff',
        background: '#010f4e',
      });
      return;
    }
  }

  async onIonInfinite() {
    await this.new_page2().then(()=>{
      console.log("cargando publicaciones");

    });
  }


  validate_is_last_page(){
    let me = this;
    me.slides.getActiveIndex().then((slidesIndex) => {
      console.log('index chnaged slides', slidesIndex);
      this.formService.lkpublication.index_close = slidesIndex;
    });
    me.slides.isEnd().then(async (istrue) => {
      if (istrue) {
        me.NextSlide = 'Finish';

        this.actualizacionservice.current_page++;
        await this.new_page2();
      } else {

        me.NextSlide = 'Next';

      }
    });
  }
  */
  
  async ngOnInit() {
    if (Capacitor.getPlatform() === 'web'){
      this.web =true;
    }
    if (this.formService.isUniversalLinkPublicationFetchFresh()) {
      this.publications = this.formService.publications || [];
      if (this.publications.length > 0) {
        this.chunkPublications();
      }
      return;
    }
    this.startPublicationSkeletonPhase();
    this.fetchPublications(true);
    this.changeChunk();
  
   
   
  }
  
  
    
  async fetchPublications(isrefresh: boolean){
    this.isFetchingPublications = true;
    this.startPublicationSkeletonPhase();
    try {
      const result = await this.actualizacionservice.getAIPublications(null, isrefresh, this.pr.id, null, null) ;
      const fetchedPublications = result || [];

      
      this.filterPublications(fetchedPublications);
    } finally {
      if (this.ChunkedPublications.length > 0) {
        this.showPublicationSkeleton = false;
      }
      this.isFetchingPublications = false;
      this.activeChunkIndex = 0;
    }
    
  }
  nextPub() {
    this.slides.slideNext(); // Method to move to the next slide
  }
  backPub(){
    this.slides.slidePrev(); // Method to move to the next slide
  }
  async filterPublications(publications) {
    //const filteredPublications = publications.filter((publication) => {
    //  if ('quienpuedever' in publication && publication['quienpuedever'].includes('Para todos')) {
    //    return true;
    //  }
    //  return false;
    //});
  
    if (publications.length > 0) {
          let NgOnInit=false;
          if(this.publications.length == 0){
            NgOnInit=true;
          }
      this.publications = publications;
          this.formService.publications = this.publications;
    
          if(NgOnInit){
             let timeou= setTimeout(() => {
        this.openComponentVideo(0,0);
        this.formService.muteAllMedia();

        }, 999);  


      }

      //this.publications = publications;
      //this.ChunkedPublications = publications;
      this.chunkPublications();
   
    }
  
    console.log('siguiendo length of pub', this.ChunkedPublications.length);
  
    if (this.ChunkedPublications.length < 1 && this.actualizacionservice.current_page <3) {
      console.log('pub < x');
      this.actualizacionservice.current_page++;
      await this.fetchPublications(false);
    }
  }
  private chunkPublications() {
    const chunkSize = 4;
    const chunkedPublications = [];
  
    let index = 0;

  
    while (index < this.publications.length) {
      const chunk = this.publications.slice(index, index + chunkSize);
      if (chunk.length > 0) {
        chunkedPublications.push(chunk);
      }
      index += chunkSize; // Update the index by the chunkSize, not the chunk length
    }


    this.ChunkedPublications = chunkedPublications;
    this.isFetchingPublications=false;
    this.showPublicationSkeleton = false;
    this.clearPublicationSkeletonPhase();

  }
  
  

  
  
  
  
  


  async handleSlideChange() {
     this.isFetchingPublications = false;
    this.formService.changeMediaPeriodically=true;
    this.formService.mostrar = false;
    const currentIndex = await this.slides.getActiveIndex();
    this.activeChunkIndex = currentIndex;
   // console.log('currentIndex',currentIndex)
    // Check if the current slide is the last slide
  if (currentIndex === (await this.slides.length()) - 1) {
  // Already fetching? Bail out to avoid duplicate calls
  if (this.isFetchingPublications) {
    console.log('Already fetching publications, ignoring new request.');
    return;
  }

  const chunkSize = 4; // or whatever your chunk size is
  // Identify the last publication currently visible (last item of the last chunk)
  const lastChunk       = this.ChunkedPublications[this.ChunkedPublications.length - 1];
  const lastPublication = lastChunk[lastChunk.length - 1];
  const lastIndex       = this.publications.indexOf(lastPublication);

  // If there are more items in this.publications that haven’t been displayed yet
  if (lastIndex < this.publications.length - 1) {
    console.log('Using pre-fetched publications to load the next chunk');

    // Build the next chunk from the subsequent publications
    const nextChunk: any[] = [];
    let i = lastIndex + 1;
    while (nextChunk.length < chunkSize && i < this.publications.length) {
      nextChunk.push(this.publications[i]);
      i++;
    }

    // Append the new chunk and remove the oldest one to keep a constant window size
    this.ChunkedPublications.push(nextChunk);
    // Remove the first chunk so we always keep only the most recent chunks
    this.ChunkedPublications.shift();

    // Slide back to the second slide so the user remains in place
    await this.slides.slideTo(1);
  } else {
    // No more pre-fetched data—fetch from the backend
    this.isFetchingPublications = true;
    console.log('Fetching additional publications from server…');
  
      await this.new_page();
    
  }
}
else if (currentIndex === 0 && this.publications.length > 16) {

  // The user scrolled to the first slide and there are older items available.
  this.loadPreviousChunk();
  console.log('loadPreviousChunk called')
}
  }
  
  ngOnDestroy() {
    this.clearWheelListener();
    clearInterval(this.timeoutId);
    clearTimeout(this.timeoutId);
    clearTimeout(this.checkIntervalId);
    this.clearPublicationSkeletonPhase();
    this.formService.changeMediaPeriodically=false;
  }

  private startPublicationSkeletonPhase(delay = 900) {
    this.showPublicationSkeleton = false;
    this.clearPublicationSkeletonPhase();
    this.publicationSkeletonTimer = setTimeout(() => {
      if (!this.formService.mediaTemplate && (this.isFetchingPublications || this.ChunkedPublications.length === 0)) {
        this.showPublicationSkeleton = true;
      }
    }, delay);
  }

  private clearPublicationSkeletonPhase() {
    if (this.publicationSkeletonTimer) {
      clearTimeout(this.publicationSkeletonTimer);
      this.publicationSkeletonTimer = undefined;
    }
  }
 private loadPreviousChunk() {
  const chunkSize = 4;
  const maxChunks  = 4; // you always show 4 chunks (16 items)

  console.log('loadPreviousChunk called');

  // Do nothing if there aren't more than 16 items
  if (this.publications.length <= chunkSize * maxChunks) {
    console.log('Not enough publications to shift backwards');
    return;
  }

  // The first publication currently visible on the first slide
  const firstPublication = this.ChunkedPublications[0][0];
 if (firstPublication === this.publications[0] /* or compare a pub ID */) {
    console.log('Already at the earliest publication; no prior chunks to load');
    return;
  }
  // Find this publication in the full list to determine where the current window starts
  const firstIndex = this.publications.indexOf(firstPublication);
  console.log('Current first publication index:', firstIndex);

  // Calculate the start index for the new window (move back by one chunk)
  const startIndex = Math.max(0, firstIndex - chunkSize);
  console.log('Start index for new window:', startIndex);

  // Build a new array of four chunks (16 items) starting from startIndex
  const newChunked: any[][] = [];
  let i = startIndex;
  while (newChunked.length < maxChunks && i < this.publications.length) {
    const chunk: any[] = [];
    for (let j = 0; j < chunkSize && i + j < this.publications.length; j++) {
      chunk.push(this.publications[i + j]);
    }
    newChunked.push(chunk);
    i += chunkSize;
  }
  console.log('New chunked length:', newChunked.length);

  // Replace the existing chunked publications and keep the user on the first slide
  this.ChunkedPublications = newChunked;
   this.slides.slideTo(2);

  console.log('ChunkedPublications updated');
   
}



  
  changeChunk(){
    this.checkIntervalId = setInterval(() => {
      if(this.ChunkedPublications.length < 1){
return;
      }
      if(this.SlideInteraction){
        this.SlideInteraction=false;
        this.timeoutId = setTimeout(() => {
          this.SlideInteraction=true;
        }, 3000);
     // console.log('status,', this.formService.changeMediaPeriodically);
      //console.log('status2,', this.duration);
      if(this.formService.user_diasabled_autoswipe ){
        return;
      }
if(!this.formService.changeMediaPeriodically && this.formService.user_diasabled_autoswipe){
return;
}else{
        Swal2.fire({
          title: 'Siguiente',
          text: ``,
          icon: 'info',
          timer: 6900, // Show the alert for 6.9 seconds
          timerProgressBar: true,
          toast: true,
          position: 'bottom-end',
          showCancelButton: true,
        showConfirmButton:true,
          cancelButtonText: '<ion-icon name="reload"></ion-icon>No',
          confirmButtonText: '<ion-icon name="play-skip-forward-sharp"></ion-icon>Si',
          color: 'black',
          background: 'white',
          }).then((result) => {
            this.formService.changeMediaPeriodically=false;
            clearTimeout(this.timeoutId);
            clearInterval(this.timeoutId);
          if (result.isConfirmed) {
  this.nextPub();
  this.formService.changeMediaPeriodically=true;
          }else{
           
            clearTimeout(this.timeoutId);
            clearInterval(this.timeoutId);
            this.formService.changeMediaPeriodically=false;
  this.timeoutId=null;
          }
          });
  
          // Set a timeout to call getRandomPosts if there is no interaction from the user
   this.timeoutId = setTimeout(() => {

    if(!this.formService.changeMediaPeriodically){
      return;
    }
    this.nextPub();
  }, 6300);
      
}
}
    }, 6900);

  
  }

  ngAfterViewInit() {

    if (localStorage.getItem('swipe_introduction_showed') != 'true') {
     this.showSwipeIntro=true;
     setTimeout(() => {
      this.showSwipeIntro=false;
      localStorage.setItem("swipe_introduction_showed","true");
      }, 9000);
     
      }
    if (localStorage.getItem('feed_swipe_hint_showed') != 'true') {
      this.showFeedSwipeHint = true;
      setTimeout(() => {
        this.showFeedSwipeHint = false;
        localStorage.setItem('feed_swipe_hint_showed', 'true');
      }, 4200);
    }
    this.slides.slideTo(this.initial_index);
    this.slides.ionSlideDidChange.subscribe(async () => {
      await this.handleSlideChange();
    });
     let me = this;
     me.slides.slideTo(this.initial_index);
     this.bindDesktopWheelNavigation();
  }

  private async bindDesktopWheelNavigation() {
    this.clearWheelListener();

    if (!this.slides) {
      return;
    }

    const host = (this.slides as any)?.el as HTMLElement;
    if (!host) {
      return;
    }

    const onWheel = async (e: WheelEvent) => {
      const direction = this.slideOpts?.direction === 'horizontal' ? 'horizontal' : 'vertical';
      const dx = e.deltaX ?? 0;
      const dy = e.deltaY ?? 0;
      const threshold = 24;
      const axisDominance = 1.2;

      const absX = Math.abs(dx);
      const absY = Math.abs(dy);

      const isVerticalIntent = absY > threshold && absY > absX * axisDominance;
      const isHorizontalIntent = absX > threshold && absX > absY * axisDominance;
      const shouldHandle = direction === 'vertical' ? isVerticalIntent : isHorizontalIntent;

      if (!shouldHandle) {
        return;
      }

      e.preventDefault();
      if (this.wheelLock) {
        return;
      }

      this.wheelLock = true;
      const amount = direction === 'vertical' ? dy : dx;

      try {
        if (amount > 0) {
          await this.slides.slideNext();
        } else {
          await this.slides.slidePrev();
        }
      } finally {
        setTimeout(() => {
          this.wheelLock = false;
        }, 330);
      }
    };

    host.addEventListener('wheel', onWheel, { passive: false });
    this.removeWheelListener = () => host.removeEventListener('wheel', onWheel as EventListener);
  }

  private clearWheelListener() {
    if (this.removeWheelListener) {
      this.removeWheelListener();
      this.removeWheelListener = null;
    }
  }
  
  
  
  
  
  async new_page() {
    try {
      this.showToast();
      this.actualizacionservice.current_page++;
      const fetchedPublications = await this.actualizacionservice.getAIPublications(null, false, null, false, null);
    
      if (!fetchedPublications || fetchedPublications.length === 0) {
        Swal2.fire({
          title: 'Your finger swipe speed exceeded the limit',
          icon: 'warning',
          confirmButtonText: 'Understood',
          color: '#ffffff',
          background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
        });
        return;
      }
    //console.log('fetchedPublications', fetchedPublications);
// Append all fetched items to the end of this.publications
this.publications.push(...fetchedPublications);

    console.log('this.publications', this.publications);
const chunkedPublications = this.chunkNewPublications(fetchedPublications);

// Append only the last four chunks from the result of chunkNewPublications()
const toAppend = Math.min(4, chunkedPublications.length);
for (let i = chunkedPublications.length - toAppend; i < chunkedPublications.length; i++) {
  this.ChunkedPublications.push(chunkedPublications[i]);
}

// Trim the stored list so it never holds more than four chunks total
while (this.ChunkedPublications.length > 4) {

  // remove the oldest chunk at the front of the array
  this.ChunkedPublications.shift();
   this.slides.slideTo(1);
}


    } catch (error) {
      console.error('Error fetching publications:', error);
    }
    
  }
  async showToast() {
    /*
    const toast = await this.toastController.create({
      message: `
        <div class="toast-content" style="background-color:black; border-radius:9px; border: solid #010f4e;">
        <img src="https://laniakea-multimedia.s3.amazonaws.com/loading_chunk.gif" alt="Image" style="width: 48px; height: 48px; border-radius:9px; border: solid white">
        </div>
      `,
      duration: 6399,
      position: 'bottom',
      cssClass: 'custom-toast detailsInModal',
      /*
      buttons: [
        {
          text: '...',
          role: 'cancel'
        }
      ]
  
    });
  
    toast.present();    */
    Swal2.fire({
      title: 'Fetching posts',
      text: ``,
      icon: 'info',
      timer: 6900, // Show the alert for 6.9 seconds
      timerProgressBar: true,
      toast: true,
      position: 'bottom-start',
    //  showCancelButton: true,
    //showConfirmButton:true,
     // cancelButtonText: '<ion-icon name="reload"></ion-icon>No',
      //confirmButtonText: '<ion-icon name="play-skip-forward-sharp"></ion-icon>Si',
      color: 'black',
      background: 'white',
      }).then((result) => {
      });
  }
  
  
  
  
  chunkNewPublications(publications) {
    const chunkSize = 4; // Define your desired chunk size here
    const chunkedArray = [];
    
    for (let i = 0; i < publications.length; i += chunkSize) {
      const chunk = publications.slice(i, i + chunkSize);
      chunkedArray.push(chunk);
    }
    
    return chunkedArray;
  }
  
  openComponentVideoTry(index, chunk){//
  console.log('chunkk',chunk);
  console.log('indexxx',index);
  const indexxx = chunk * 4 + index;
    this.Mctrl.create({
        component: LkfilmViewBySlidesComponent,
        cssClass: 'detailsInModal',
        canDismiss: true, // (forced globally for swipe close on all modals)
        componentProps: {
          publications: this.publications,
          index: indexxx,
          valueSelect: 'MENU'
        }
    }).then((modal)=>{
        modal.present();
    });
}

openComponentVideo(index: number, chunk: number) {
  
  try {
   
    this.formService.mostrar = false;
    //console.log('pubs', this.publications);
    this.formService.publications = this.publications;
    const indexxx = chunk * 4 + index;
    //this.initial_index = indexxx;
    this.formService.index = indexxx;
    this.formService.valueSelect = 'MENU';
    this.formService.mediaTemplate = true;

    // Log some information to check the values before opening the component
    console.log('Index:', index);
    console.log('Chunk:', chunk);
    console.log('Indexxx:', indexxx);
    
  } catch (error) {
    console.error('Error in openComponentVideo:', error);
  }
}



Mostrar(){
  if(this.mostrar== false){
    this.mostrar=true
  this.formService.mostrar = true;
    console.log('swiped',this.formService.mostrar );
  }else{
    this.mostrar=false
  this.formService.mostrar = false;
    console.log('swiped',this.formService.mostrar );
  }
}
formatCounter(value: number): string {
  if (value >= 1000000000000) {
    return (value / 1000000000000).toFixed(1) + 'T';
  } else if (value >= 1000000000) {
    return (value / 1000000000).toFixed(1) + 'B';
  } else if (value >= 1000000) {
    return (value / 1000000).toFixed(1) + 'M';
  } else if (value >= 1000) {
    return (value / 1000).toFixed(1) + 'K';
  } else {
    return value.toString();
  }
}


}



///PROXIMAMENTE...
/*
async presentToast(pub) {

  this.ionViewillEnter(pub);

}
ionViewillEnter(pub) {
  this.faio.show({
    title: "Leyendo huella Digital",
    subtitle: "Use su huella para permitir el acceso a retiros",
  })
    .then((res) => {
      this.lanzamiento = setInterval(() => {
        this.mostrar = true
        console.log(`lanzamiento en ${this.numero}`);
        this.numero--
    
        if (this.numero === 0) {
          clearInterval(this.lanzamiento);
          console.log("Se terminó el tiempo con Exito!!");
    
          setTimeout(() => {
            this.mostrar = false;
            this.numero = 10;
          }, 4000);
          // Call envioRegalo() here
          this.openKYCApplicationModal(pub);
        }
      }, 1200);
      console.log(res);
      this.msg = 'Se valido el acceso con tu huella';
  
    })
    .catch((err) => {
      console.log(err);
      this.msg = 'Acceso incorrecto';
      alert(err);
    });
}
private openKYCApplicationModal(pub) {
		console.log('openKYCApplicationModal called');
		this.walletService.KYC_validation().then((result_kyc) => {
			console.log('KYC_validation result:', result_kyc);
		  if (result_kyc['permit']) {
			this.subscribedToProductGifts(pub);
		  } else if (this.pr.kyc === "Sin Validar") {
			this.showPagoVerificacionModal();
		  } else {
			this.showPagoVerificacionModal();
		  }
		}).catch((error) => {
			console.error('KYC_validation error:', error);
		  console.error(error);
		});
	  }
    private showSliderInformationModal() {
      console.log('showSliderInformationModal called');
      this.Mctrl.create({
        component: SliderInformationComponent,
        componentProps: {
        pr: this.pr,
        },
      }).then((modal) => {
        modal.present();
      }).catch((error) => {
        console.error(error);
      });
      }
      private showPagoVerificacionModal() {
        console.log('showPagoVerificacionModal called');
        console.log("entro al else if ");
        
        this.Mctrl.create({
          component: PagoVerificacionComponent,
          canDismiss: true, // (forced globally for swipe close on all modals)
          componentProps: {
          pr: this.pr
          }
        }).then((modal) => {
          modal.present();
        });
        }
        async envioRegalo(pub) {
          if (!this.HubbleExpired){
          this.secureFeedback.begin('Autorizando regalo');
          const data = {
            monto: '1',
            divisa: 'MXN',
            receiver_id: pub.user_id,
            publication_id: pub.id,
            user_id: this.pr.id,
          };
        
          this.request.createRequestPost('store_regalo', data).then(async (result: any) => {
            if (result.title === 'Error al enviar el regalo') {
              this.secureFeedback.fail('No se pudo enviar el regalo');
              // If the server returned an error, show an error Swal2.fire
              Swal2.fire({
                title: result.title,
                text: result.message,
                icon: 'error',
                confirmButtonText: 'Understood',
                color: '#ffffff',
                background: '#010f4e',
              });
            } else {
			  this.secureFeedback.succeed('Regalo enviado');
			  this.socialNotifications.notifyLocal(
				'Regalo enviado',
				'Tu regalo fue enviado correctamente.',
				{ event_type: 'gift_sent', publication_id: pub.id },
			  );
              // If the server returned a success, show a success Swal2.fire
              Swal2.fire({
                title: 'Regalo enviado a publicación con Success',
                icon: 'success',
                confirmButtonText: 'Understood',
                color: '#ffffff',
                background: '#010f4e',
              });
             // Fetch the updated gift count
             
            }
          }).catch((error) => {
            this.secureFeedback.fail('No se pudo enviar el regalo');
            // Handle the error here
            console.error('Error sending gift:', error);
          });
        }
        }
        async RenewSuscription(pub): Promise<void> {
          Swal.fire({
            title: 'User subscription...',
            text: 'Your verified user subscription has expired. Please wait...',
            icon: 'success',
            timer: 4500, // Show the alert for 4.5 seconds
            timerProgressBar: true,
            toast: true,
            position: 'top-end',
            showConfirmButton: false
            });
          return new Promise<void>(async (resolve, reject) => {
            this.store.verbosity = this.store.DEBUG;
          
            // Register the product with the given ID
            this.store.register({
            id: this.productId2,
            alias: this.productId2,
            type: this.store.PAID_SUBSCRIPTION, // Change the type to PAID_SUBSCRIPTION
            });
          
            // Fetch the product information
            const product = await this.store.get(this.productId2);
          
            // Updated
            this.store.when(this.productId2).updated((product: IAPProduct) => {
           
              console.log('Updated' + JSON.stringify(product));
              });
          
            // User closed the native purchase dialog
            this.store.when(this.productId2).cancelled((product) => {
            console.error('Purchase was Cancelled');
            });
          
            // Run some code only when the store is ready to be used
            this.store.ready(() => {
            console.log('Store is ready');
            console.log('Products: ' + JSON.stringify(this.store.products));
            console.log(JSON.stringify(this.store.get(this.productId2)));
            });
          
            if (product) {
            // Check if the product is already owned
            if (product.state === this.store.OWNED) {
              //this.envioRegalo(pub);
              console.log('Product already owned');
              resolve();
              return;
            }
          
            // Check if the product is invalid
            if (product.state === this.store.INVALID) {
              reject(new Error('Product is invalid'));
              return;
            }
          
            // To make a purchase
            this.store.order(this.productId2);
          
            // Proceed with the purchase flow
            this.store.when(this.productId2).approved((product) => {
              product.finish();
          
              console.log('Subscription ordered!');
          
              this.store.when(this.productId2).owned(async (product) => {
                this.envioRegalo(pub);
              console.log('Product is owned');
              this.sendNotification('Estatus de tu perfil actualizado', '¡Felicitaciones! Ya tienes acceso a la cartera Hubble.');
              
              });
            });
          
            // Handle error events
            this.store.when(this.productId2).error((err) => {
              console.log('Error occurred during purchase:', err);
              reject(err);
            });
          
            // Refresh the product information
            this.store.refresh();
            } else {
            reject(new Error('Failed to fetch product information'));
            }
          
          });
          }
          async subscribedToProductGifts(pub): Promise<void> {
            Swal.fire({
              title: 'Procesando...',
              text: 'Hubble is processing.',
              icon: 'success',
              timer: 3000, // Show the alert for 3.9 seconds
              timerProgressBar: true,
              toast: true,
              position: 'top-end',
              showConfirmButton: false
            });
            
            this.store.register({
              id: this.productId2,
              alias: this.productId2,
              type: this.store.PAID_SUBSCRIPTION, // Change the type to PAID_SUBSCRIPTION
            });
            
            // Fetch the product information
            const product = await this.store.get(this.productId2);
            
            // Updated
            this.store.when(this.productId2).updated((product: IAPProduct) => {
              console.log('Updated: ' + JSON.stringify(product));
              if (product.owned)  this.envioRegalo(pub);
            else this.RenewSuscription(pub);
            });
            
            // User closed the native purchase dialog
            this.store.when(this.productId2).cancelled((product) => {
              console.error('Purchase was Cancelled');
            });
            
            // Run some code only when the store is ready to be used
            this.store.ready(() => {
              console.log('Store is ready');
              console.log('Products: ' + JSON.stringify(this.store.products));
              console.log(JSON.stringify(this.store.get(this.productId2)));
            });
            // Handle error events
            this.store.when(this.productId2).error((err) => {
            console.log('Error occurred during purchase:', err);
            
            });
          
            // Refresh the product information
            this.store.refresh();
            
            }
          
          sendNotification(title, body) {
           
          return new Promise((resolve, reject) => {
            const notification = {
            title: title,
            body: body,
            user_id:this.pr.id,
        
            };
          
            this.request.createRequestPost('GreatAtractorNotifications', notification)
            .then((data) => {
             
              resolve(data);
            }).catch((error) => {
              console.error('Failed to send notification:', error);
              reject(error);
            });
          });
          }
         
          
}
*/
